import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-sql-sentence',
  templateUrl: './dialog-sql-sentence.component.html',
  styleUrls: ['./dialog-sql-sentence.component.scss']
})
export class DialogSqlSentenceComponent implements OnInit {

    public dados: any = [];    
    editorOptions = {theme: 'vs-dark', language: 'sql', readOnly :true};
    
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DialogSqlSentenceComponent>,
    ) {
        this.dados = data;
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
    
}
